<template>
  <div class="firstPrograms">
    <cs-form ref="programValidForm" class="header-search-box padding-t-20" label-width="90px" form-width="100%" :inline="true"
        :form="searchParams"
        :formData="searchData"
        :form-col="searchFormCol">
      <template slot="search">
        <el-button size="small" type="primary" @click="searchHandle">查询</el-button>
        <el-button size="small" @click="resetHandle('programValidForm')">重置</el-button>
      </template>
    </cs-form>
    <cs-table ref="tableProgram"  :tableCols="tableCols" :tableData="tableData"
        :paginationOption="pageOption"
        @size-change="sizeChangeHandle"
        @current-change="currentPageHandle">
      <template slot-scope="scope" slot="auditTime">
        {{scope.row.auditTime | timeFormat}}
      </template>
      <template slot="control" slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="发布" placement="top">
          <i @click="releaseEvent(scope.row)" class="icon-fabu icon-size"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="详情" placement="top">
          <i @click="detailEvent(scope.row)" class="icon-xiangxi icon-size"></i>
        </el-tooltip>
      </template>
    </cs-table>
    <!-- 发布Dialog -->
     <ReleaseDialog ref="releaseDialog" :dialogData="dialogReleaseData" @addSuccess="pageInit"/>
    <!-- 详情Dialog -->
    <ReleaseDetail ref="releaseDetail" :dialogData="dialogReleaseData"/>
  </div>
</template>
<script>
import { fetchProgramSets } from '@/resource/api/index'
import ReleaseDialog from './release-dialog.vue'
import ReleaseDetail from './detail-dialog.vue'
export default {
  name: 'ProgramCollect',
  components: {
    ReleaseDialog,
    ReleaseDetail
  },
  data () {
    return {
      searchParams: { // 节目集发布表单
        name: '',
        operator: '',
        auditState: 'RE_AUDIT_PASS',
        id: '',
        limit: 20,
        offset: 1
      },
      searchFormCol: { gutter: 10, sm: 12, md: 8, lg: 6 },
      tableCols: [ // 节目集发布表头
        { prop: 'category', label: '分类' },
        { prop: 'name', label: '节目集名称' },
        { prop: 'seriesAmount', label: '总集数' },
        { prop: 'newestSeriesNo', label: '最新集数' },
        { prop: 'auditTime', label: '审核通过时间', type: 'slot' },
        { prop: 'control', label: '操作', type: 'slot', width: 160 }
      ],
      tableData: [], // 节目集列表
      pageOption: {}, // 节目集发布分页参数
      dialogReleaseData: {}
    }
  },
  created () {
    this.pageInit()
  },
  methods: {
    pageInit () {
      this.searchParams.operator = this.$store.state.router.createBySuffix
      this.pageOption['page-size'] = this.$store.state.pageLimit
      this.searchParams.limit = this.$store.state.pageLimit
      this.currentPageHandle(1)
      this.$nextTick(() => {
        this.$refs.tableProgram.clearSelection()
      })
    },
    // 搜索
    searchHandle () {
      this.currentPageHandle(1)
    },
    // 重置
    resetHandle (formName) {
      this.$refs[formName].resetFields()
    },
    // 节目集发布列表
    getProgramsData () {
      fetchProgramSets(this.searchParams).then((res) => {
        if (res.code == '1') {
          this.tableData = res.results
          this.pageOption = {
            ...this.pageOption,
            'current-page': this.searchParams.offset,
            total: parseInt(res.total)
          }
        }
      })
    },
    // 批量发布
    releaseHandle (val) {
      this.$nextTick(() => { // 等待dom同步后打开模态框
        this.$refs.releaseDialog.openDialog()
      })
    },
    // 发布
    releaseEvent (row) {
      this.dialogReleaseData = {
        title: '发布',
        isProgram: '节目集',
        dataObj: row
      }
      this.$nextTick(() => { // 等待dom同步后打开模态框
        this.$refs.releaseDialog.openDialog()
      })
    },
    // 详情
    detailEvent (row) {
      this.dialogReleaseData = {
        title: '详情',
        dataObj: row,
        isProgram: '节目集'
      }
      this.$nextTick(() => { // 等待dom同步后打开模态框
        this.$refs.releaseDetail.openDialog()
      })
    },
    sizeChangeHandle (val) {
      this.searchParams.limit = val
      this.searchParams.offset = 1
      this.getProgramsData()
    },
    currentPageHandle (val) {
      this.searchParams.offset = val
      this.getProgramsData()
    }
  },
  computed: {
    searchData () {
      return [
        {
          prop: 'name',
          type: 'input',
          label: '节目集名称：',
          placeholder: '请输入节目集名称',
          labelWidth: '100px',
          col: [3, 3, 3]
        },
        {
          prop: 'id',
          type: 'input',
          label: '节目集ID：',
          placeholder: '请输入节目集ID',
          labelWidth: '100px',
          col: [3, 3, 3]
        },
        { prop: 'search', type: 'slot', label: '', col: [3, 3, 3] }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
  .icon-size {
    padding-right: 10px;
    cursor: pointer;
  }
</style>
